import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { SaveAction } from "../../../components/Posts/PostForm/types";
import { PostStatesType } from "../../../constants/PostsView";
import capitalize from "lodash/capitalize";
import { Button } from "../../../components/ui/button";
import { Spinner } from "../../../components/ui/spinner";
import { hotkeyManager } from "../../../ui/SkedCaption/hot-key-manager";
import { ShortcutKey } from "../../../ui/shortcut-key";

export const PostSaveButton = ({
  disabled,
  onSave,
  postState,
  isPostNow,
  isSubmitting,
  compact,
  label,
}: {
  disabled?: boolean;
  onSave?: (action: SaveAction) => void;
  postState: PostStatesType;
  isPostNow: boolean;
  isSubmitting?: boolean;
  compact?: boolean;
  label?: string;
}) => {
  const saveLabel = label ?? resolvePostStateSaveLabel(postState, isPostNow);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Button
            onClick={() => onSave?.("save-and-show-success-screen")}
            disabled={disabled || isSubmitting}
            size={compact ? "sm" : "md"}
            variant="blue-primary"
            className={
              compact
                ? "min-w-[57px] w-auto rounded-lg px-3 shadow-[0_1px_2px_rgba(16,24,40,0.05)]"
                : undefined
            }
          >
            {isSubmitting ? (
              <span className="flex items-center gap-2">
                <Spinner size="sm" variant="inverted" />
                Saving...
              </span>
            ) : (
              capitalize(saveLabel)
            )}
          </Button>
        </div>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        className="bg-white rounded-lg text-black [&_*]:text-neutral-800 border border-neutral-100"
      >
        <div className="flex flex-col gap-[8px] text-[8px] text-neutral-800 leading-[12px]">
          <div className="flex gap-[4px] align-center">
            {hotkeyManager.isMac() ? (
              <ShortcutKey>
                <span>⌘</span>
              </ShortcutKey>
            ) : (
              <ShortcutKey>
                <span>Ctrl</span>
              </ShortcutKey>
            )}
            <ShortcutKey>
              <span>Enter</span>
            </ShortcutKey>
            to{" "}
            {label?.toLowerCase() ??
              resolvePostStateSaveLabel(postState, false)}{" "}
            post
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

function resolvePostStateSaveLabel(
  postState: PostStatesType,
  isPostNow: boolean
): string {
  switch (postState) {
    case "DRAFT": {
      return "save";
    }
    case "SCHEDULED": {
      if (isPostNow) {
        return "post now";
      }
      return "schedule";
    }
    case "QUEUED": {
      return "queue";
    }
  }
  return "save";
}
